module.exports = __webpack_public_path__ + "media/00.65548fe2.mp3";